import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton } from '@mui/material';
import { MouseEvent } from 'react';

/** Props passed by react-toastify to custom close button components. */
interface ToastCloseButtonProps {
  closeToast?: (event: MouseEvent<HTMLElement>) => void;
}

/** Renders the standard close button used by toast notifications. */
export function ToastCloseButton({ closeToast }: ToastCloseButtonProps) {
  return (
    <Box
      sx={{
        alignSelf: 'flex-start',
        display: 'inline-flex',
        flexShrink: 0,
        height: 'fit-content',
      }}
    >
      <IconButton
        size="small"
        onClick={closeToast}
        sx={{
          color: 'text.secondary',
          '&:hover': {
            color: 'text.primary',
            bgcolor: 'action.hover',
          },
        }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  );
}
